import PaymentFormCreate from "./PaymentFormCreate";
import PaymentFormUpdate from "./PaymentFormUpdate";
import PaymentFormDelete from "./PaymentFormDelete";

export const Payment = {
  Create: PaymentFormCreate,
  Update: PaymentFormUpdate,
  Delete: PaymentFormDelete,
};
